import type {
	LoginFlow,
	UiNodeGroupEnum,
	UpdateLoginFlowBody,
} from "@ory/kratos-client";
import type React from "react";
import { useState } from "react";
import {
	ContentContainer,
	ContentContainerWrapper,
} from "~/components/ContentContainer";
import { Flow, type Methods, type NodeDisabler } from "~/components/KratosFlow";
import { DefaultLayout } from "~/components/Layout";

const getMethodText = (method: Methods): string => {
	switch (method) {
		case "webauthn":
			return "Use Security key";
		case "password":
			return "Use Password";
		default:
			return "";
	}
};

const getNodeDisablers = (
	method: UiNodeGroupEnum,
): NodeDisabler<UpdateLoginFlowBody>[] => {
	switch (method) {
		case "password":
			return [
				{
					target: { name: "method", value: "password" },
					keys: ["password" as keyof UpdateLoginFlowBody],
					allowEmpty: false,
					allowNotChanged: false,
				},
			];
		default:
			return [];
	}
};

interface Props {
	onSubmit: (values: UpdateLoginFlowBody) => Promise<void>;
	flow: LoginFlow;
}

export const ReAuthentication: React.FC<Props> = ({ flow, onSubmit }) => {
	const [preferGroup, setPreferGroup] = useState<Methods>("webauthn");
	const hasGroup = (flow: LoginFlow, want: UiNodeGroupEnum) =>
		flow.ui.nodes.some(({ group }) => group === want);
	const candidates: Methods[] = ["webauthn", "password"];
	const groups = candidates
		.filter((group) => hasGroup(flow, group))
		.sort((a, b) => {
			if (a === preferGroup) return -1;
			if (b === preferGroup) return 1;
			return 0;
		});

	return (
		<>
			<title>Re Authenticate | TIER IV Account</title>
			<DefaultLayout>
				<ContentContainerWrapper>
					<ContentContainer>
						<h1 className="mt-10 text-center font-normal">CONFIRM ACCESS</h1>
						<Flow
							onSubmit={onSubmit}
							flow={flow}
							only={groups[0]}
							nodeDisablers={getNodeDisablers(groups[0])}
							hideGlobalMessagesTypes={["info"]}
						/>
						{groups.length >= 2 && (
							<>
								<div className="divider mt-6">
									Change Method<span className="font-semibold">?</span>
								</div>
								{groups.slice(1).map((method) => {
									return (
										<button
											type="button"
											key={method}
											className="block w-full text-center mt-6 cursor-pointer"
											onClick={() => setPreferGroup(method)}
										>
											{getMethodText(method)}
										</button>
									);
								})}
							</>
						)}
					</ContentContainer>
				</ContentContainerWrapper>
			</DefaultLayout>
		</>
	);
};
